import React from 'react';
import IconConcierge from '@spothero/icons/user-pin';
import IconPublicTransit from '@spothero/icons/train-filled';
import IconCar from '@spothero/icons/car';
import SpotImages from 'common/spot-details/spot-images';
import SpotUtils from 'utils/spot';
import { CarouselVariant } from 'common/image-carousel';
import { Flex, Heading, Icon, Box } from '@spothero/ui';
export const ShuttleInformation = ({ shuttle, facilityTitle, iataCode, }) => {
    const { type, duration, fast_frequency: fastFrequency, slow_frequency: slowFrequency, hours: accessHours, images, } = shuttle;
    const accessHoursFormatted = accessHours?.periods?.length
        ? SpotUtils.formatAccessHours(accessHours)
        : null;
    const frequencySpan = fastFrequency && slowFrequency
        ? `${fastFrequency} - ${slowFrequency}`
        : fastFrequency || slowFrequency || '';
    let subtitle = 'Shuttle Information';
    if (type === 'curbside-valet') {
        subtitle = 'Curbside Dropoff';
    }
    else if (type === 'public-transit') {
        subtitle = 'Accessible via Public Transit';
    }
    return (<Flex direction="column" paddingY={6} paddingX={4} marginTop={2} marginX={4} marginBottom={0} borderTopWidth="1px" data-testid="ShuttleInformation">
            <Heading fontSize="base" marginBottom={4} as="h4">
                {subtitle}
            </Heading>

            {type === 'taxi' && (<Flex>
                    <Icon as={IconCar} color="gray.dark" width={5} height={5} paddingRight={1}/>
                    No shuttle available.
                </Flex>)}
            {type === 'public-transit' && (<Flex>
                    <Icon as={IconPublicTransit} color="gray.dark" width={5} height={5} paddingRight={1}/>
                    No shuttle available, public transit on site.
                </Flex>)}
            {type === 'curbside-valet' && (<Flex>
                    <Icon as={IconConcierge} color="gray.dark" width={5} height={5} paddingRight={1}/>
                    Concierge service curbside dropoff.
                </Flex>)}
            {(type === 'scheduled' ||
            type === 'scheduled-shuttle' ||
            type === 'on-demand' ||
            type === 'on-demand-shuttle') && (<Flex flexDirection={{ base: 'column', tablet: 'row' }}>
                    <Box as="dl" marginBottom={4} fontWeight="semibold" flex="1">
                        {frequencySpan && (<Box>
                                <Box as="dt" fontSize={{ base: 'xs', tablet: 'sm' }} marginBottom={0.5} color="gray.dark">
                                    Frequency
                                </Box>
                                <Box as="dd" fontSize="sm" marginBottom={{ base: 3, tablet: 4 }}>
                                    {frequencySpan &&
                    `Every ${frequencySpan} mins`}
                                </Box>
                            </Box>)}
                        <Box>
                            <Box as="dt" fontSize={{ base: 'xs', tablet: 'sm' }} marginBottom={0.5} color="gray.dark">
                                Duration to {iataCode}
                            </Box>
                            <Box as="dd" fontSize="sm" marginBottom={{ base: 3, tablet: 4 }}>
                                {duration} mins
                            </Box>
                        </Box>
                        <Box>
                            <Box as="dt" fontSize={{ base: 'xs', tablet: 'sm' }} marginBottom={0.5} color="gray.dark">
                                Shuttle Hours
                            </Box>
                            <Box as="dd" fontSize="sm" marginBottom={{ base: 3, tablet: 4 }}>
                                {accessHours.text &&
                accessHours.text.length === 1 &&
                'Operates 24/7'}
                                {accessHoursFormatted &&
                accessHoursFormatted.map((period, i) => {
                    return (<Box key={i} textTransform="capitalize" marginBottom={2}>
                                                {period.days}, {period.value}
                                            </Box>);
                })}
                            </Box>
                        </Box>
                    </Box>
                    {Boolean(images.length) && (<Box borderRadius="8px" overflow="hidden" width={{ base: '100%', tablet: '50%' }}>
                            <SpotImages images={images} alt={`${facilityTitle} shuttle images`} carouselVariant={CarouselVariant.SINGLE} carouselHeight={16}/>
                        </Box>)}
                </Flex>)}
        </Flex>);
};
export default ShuttleInformation;
